module.exports = __webpack_public_path__ + "img/clock-eleven.aadfabc5.svg";